export const ORDER_FORM_ID = 'kit-order-form';
export const DIGITAL_ORDER_FORM_ID = 'kit-digital-order-form';
